import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Stripe from 'constants/stripe'

const Card = ({ input, meta }) => {
  const stripe = Stripe()
  const cardNumberRef = useRef(null)
  const cardExpiryRef = useRef(null)
  const cardCvcRef = useRef(null)
  const cardNameRef = useRef(null)
  const { cardArr, generateToken } = stripe
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    // assign reference to it
    stripe.mountCardNumber(cardNumberRef.current) // mounts the created stripe element
    stripe.mountCardExpiry(cardExpiryRef.current)
    stripe.mountCardCvc(cardCvcRef.current)

    cardArr.forEach(card => {
      card.addEventListener('change', async ({ complete, error }) => {
        if (complete) {
          const { token } = await generateToken(cardNameRef.current.value)
          if (token) { input.onChange(token.id); }
        }

        return setErrorMessage(!error ? '' : error.message)
      })
    })
  }, [])

  // @TODO: Doesn't validate the card name BUT it doesn't matter since its purpose is only for additional payment info
  return (
    <div className="flex flex-col w-full">
      <div className="my-2">
        <label className="text-lg">
          Card Number
        </label>
        <div className="mt-2 border border-grey-light w-full p-3 rounded-lg" ref={cardNumberRef} />
      </div>
      <div className="my-2">
        <label className="block text-lg">
          Name on card
        </label>
        <input className="mt-2 border border-grey-light w-full p-2 rounded-lg" placeholder="Name" type="text" ref={cardNameRef} />
      </div>
      <div className="flex my-2">
        <div className="w-1/2 mr-2">
          <label className="text-lg">
            Expires
          </label>
          <div className="mt-2 border border-grey-light w-full p-3 rounded-lg" ref={cardExpiryRef} />
        </div>
        <div className="w-1/2 ml-3">
          <label className="text-lg">
            CVC
          </label>
          <div className="mt-2 border border-grey-light w-full p-3 rounded-lg" ref={cardCvcRef} />
        </div>
      </div>
      {/* this is the redux form field that waits for token value */}
      <input {...input} type="hidden" />
      {errorMessage && <p className="form-error text-action-danger text-xs">{errorMessage}</p>}
      {meta.touched && meta.error && (
        <p className="form-error text-action-danger text-xs">{meta.error}</p>
      )}
    </div>
  )
}

Card.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
}
export default Card
